import { ChapterConfig } from "../../ChapterConfig";
import './WorkSpace.scss'
import { FreeSpace } from "../../../Comps/FreeSpace/FreeSpace";
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox";

export function WorkSpace(props:ChapterConfig){                    

    return  <div>
                <h1>Workspace</h1>
                <OutlineBox><FreeSpace soundMode={null}/></OutlineBox>
            </div>
}
